/**
 * Servicio de inicialización y estado para ConsultaRedV2
 * Maneja la actualización de estado en el componente de forma centralizada
 */

export class ConsultaRedV2StateManager {
  /**
   * Construye el estado inicial para antes de realizar la consulta
   * @param {object} eventData - Datos extraídos del evento
   * @returns {object}
   */
  static buildInitialState(eventData) {
    const { promotionData, specialtyValue, isPromotionActive, validationDataPromotion } = eventData;

    return {
      showEspecialidadesPopup: true,
      dateseted: false,
      viewDates: false,
      sedesSeted: false, 
      cupsEvent: eventData,
      specialityValueSelected: specialtyValue,
      checkedDoctorInit: true,
      responseContent: false,
      personalDoctor: false,
      hideSedes: true,
      nameService: promotionData.nameService,
      noPlacerholderSpec: true,
      serviceCode: specialtyValue,
      validationDataPromotion: validationDataPromotion,
      isPromotionAndPrevention: promotionData.promotion,
      specialitySelected: specialtyValue,
      infoIsPromotionActive: {
        name: promotionData.name,
        image: promotionData.imageUrl,
        description: promotionData.description,
      },
      namePlaceholderSpec: promotionData.nameService,
    };
  }

  /**
   * Construye el estado después de una respuesta exitosa V2
   * @param {object} processedData - Datos procesados del servicio
   * @param {boolean} groupProgram - Si el usuario es de programa de grupo
   * @returns {object}
   */
  static buildSuccessState(processedData, groupProgram = false) {
    const { medicalAvailable, branches, hasPersonalDoctor, oneBranche, selectedBranch } = processedData;

    // Hay médico asignado si existe médico personal O médico tratante con nombre
    const hasAssignedDoctor = !!(
      medicalAvailable?.AssignedDoctor && medicalAvailable.AssignedDoctor.FullName !== ''
    );

    const stateUpdate = {
      viewDates: true,
      responseContent: true,
      medicalAvailable: medicalAvailable,
      newBranchesRedService: branches,
      baseBranches: branches,
      enableButtonComplete: true,
      isRedService: true,
      hideSedes: hasAssignedDoctor,
      checkedDoctorInit: hasAssignedDoctor,
      personalDoctor: hasPersonalDoctor,
      sedesSeted: (groupProgram || hasAssignedDoctor),
    };

    // Si tiene médico asignado (personal o tratante): buscar cita por médico (statusRequest 1)
    if (hasAssignedDoctor) {
      stateUpdate.statusRequest = 1;
    }

    // Si solo hay una sede: buscar cita por sede (statusRequest 2)
    if (oneBranche && selectedBranch) {
      stateUpdate.oneBrancheSelected = selectedBranch;
      stateUpdate.oneBranche = true;
      stateUpdate.sedesSeted = true;
      stateUpdate.statusRequest = 2;
    }

    return stateUpdate;
  }

  /**
   * Construye el estado cuando hay citas asignadas
   * @param {string} specialtyValue - Código de especialidad
   * @returns {object}
   */
  static buildAssignedAppointmentState(specialtyValue) {
    return {
      sinCitas: true,
      enableButtonComplete: true,
      viewDates: true,
      specialtySelected: specialtyValue ?? '',
      serviceCode: specialtyValue,
      checkedDoctorInit: true,
    };
  }

  /**
   * Construye el estado de error
   * @param {object} errorInfo - Información del error
   * @returns {object}
   */
  static buildErrorState(errorInfo) {
    return {
      error: true,
      isRedService: false,
      responseContent: false,
    };
  }

  /**
   * Construye el estado cuando hay incumplimientos
   * @param {object} nonComplianceData - Datos de incumplimientos procesados
   * @returns {object}
   */
  static buildNonComplianceState(nonComplianceData) {
    return {
      // Este estado se manejará en el componente al mostrar modales
      // Esta función solo facilita la estructura de datos
      nonComplianceInfo: nonComplianceData,
    };
  }

  /**
   * Construye información de incumplimiento para sessionStorage
   * @param {object} options - { nonComplianceData, affiliatesLength, state, serviceCode, namePlaceholderSpec }
   * @returns {object}
   */
  static buildNonComplianceInfo(options) {
    const {
      nonComplianceData,
      affiliatesLength,
      state,
      serviceCode,
      namePlaceholderSpec,
    } = options;

    const { pedagogic } = nonComplianceData;
    const firstAuthNumber = pedagogic.length > 0 ? pedagogic[0].NumAutorizacion : '';

    if (affiliatesLength > 1) {
      return {
        userTypeId: state.selectedUserTypeID,
        userId: state.selectedUserId,
        authorizationNumber: firstAuthNumber,
        program: state.dataToSubmitAppoimentGroup,
        nameService: namePlaceholderSpec,
        serviceCode: serviceCode,
        beforePage: 1,
      };
    } else {
      return {
        userTypeId: state.userInfo.TipoIdentificacion,
        userId: state.userInfo.LegalID,
        authorizationNumber: firstAuthNumber,
        program: state.dataToSubmitAppoimentGroup,
        nameService: namePlaceholderSpec,
        serviceCode: serviceCode,
        beforePage: 1,
      };
    }
  }
}
